import React, { FunctionComponent, useEffect } from "react";
import styles from "./LogosSponsors.module.scss";
import LogosSponsorsProps from "./LogosSponsorsProps.interface";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import BubbleBackground from "components/BubbleBackground/BubbleBackground";
import combineClasses from "helpers/combine-classes";
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useAnchorIdentifier from "hooks/useAnchorIdentifier";
import isBrowserContext from "helpers/isBrowserContext";

const LogosSponsors: FunctionComponent<LogosSponsorsProps> = (props) => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const identifier = useAnchorIdentifier(props.settings.anchorIdentifier);

    // ANIMATION
    const controls = useAnimation();
    const { ref, inView } = useInView({ threshold: 0.3 });

    const animateUp = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: 80, opacity: 0 }
    };
    const animateDown = {
        visible: { y: 0, opacity: 1 },
        hidden: { y: -80, opacity: 0 }
    };

    const selectAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content._contentType : undefined;
    const selectVariants = selectAnimation === "animateUp" ? animateUp : selectAnimation === "animateDown" ? animateDown : undefined;
    const repeatAnimation = props.settings.animation && props.settings.animation.length > 0 ? props.settings.animation[0].content.repeatAnimation : false;

    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
        if (!inView && repeatAnimation) {
            controls.start("hidden");
        }
    }, [controls, inView]);

    if (props.settings?.width) {
        wrapperClasses.push(styles[`width_${props.settings.width}`]);
    }

    return (
        <motion.section className={combineClasses([styles.wrapper, ...wrapperClasses])} id={identifier} ref={ref} initial={isBrowserContext() ? "hidden" : "shown"} animate={controls} variants={selectVariants} transition={{ duration: 0.4 }}>
            <div className={styles.inner}>

                {props.content?.logos && props.content?.logos.length > 0 ?
                    <div className={styles.sponsors}>
                        {/* Headline */}
                        {props?.content?.headline ?
                            (<h1 className={styles.sponsors_heading}>{props?.content?.headline}</h1>) : null}

                        {/* Sponsors Logos */}
                        <div className={styles.logos}>
                            {props.content?.logos.map((logo: any) => {
                                return logo.content.image ? (<ImageViewer key={logo.contentUdi} alt={logo.content.alternative ? logo.content.alternative : "Sponsor Logo"} className={styles.logo_image} src={logo.content.image._url ? logo.content.image._url : ""} />) : null;
                            })}
                        </div>
                    </div>
                    : null}
            </div>

            {props.settings.bubbleBackground && props.settings.bubbleBackground.length > 0 ? (
                <BubbleBackground {...props.settings.bubbleBackground[0]} />
            ) : null}
        </motion.section>
    );
};

export default LogosSponsors;